import React, { useEffect, useState } from "react";
import { Modal } from "semantic-ui-react";
import { NavLink } from "react-router-dom";
import ReactTable from "react-table";
import "react-table/react-table.css";
import moment from "moment";
import { useAuth } from "../../../AuthenticationStore";

const Campaigns = () => {
  const { campaignService } = useAuth();
  const [dataCampaigns, setDataCampaigns] = useState([]);
  const [loadData, setLoadData] = useState(true);
  const [dialongDiscard, setDialongDiscard] = useState(false);
  const [campaignInfo, setCampaignInfo] = useState([]);

  useEffect(() => {
    if (!campaignService) return;
    const getCampaigns = async () => {
      setLoadData(true);
      const responseCampaigns = await campaignService.getCampaigns();
      setDataCampaigns(responseCampaigns.object || []);
      setLoadData(false);
    };
    getCampaigns();
  }, [campaignService]);

  const show = () => setDialongDiscard(true);
  const close = () => setDialongDiscard(false);

  const discardCampaigAlert = (campaignId, index) => {
    setCampaignInfo([index, campaignId]);
    show();
  };

  const discardCampaign = async () => {
    setLoadData(true);
    close();
    let dataTemp = [...dataCampaigns];
    dataTemp.splice(campaignInfo[0], 1);
    setDataCampaigns(dataTemp);
    const result = await campaignService.discardCampaign(campaignInfo[1]);
    if (result.cdExceptions && result.cdExceptions.length > 0) {
      for (let i = 0; i < result.cdExceptions.length; i++) {
        const ms = result.cdExceptions[i]["exception"];
        alert(ms);
      }
    }
    setLoadData(false);
  };

  return (
    <div className="container">
      <Modal size="mini" open={dialongDiscard} onClose={() => close()}>
        <Modal.Header className="bg-primary">
          <i className="fa fa-trash-o"></i> Confirmaci&oacute;n
        </Modal.Header>
        <Modal.Content>
          <p>Esta seguro de descartar la campaña?</p>
        </Modal.Content>
        <Modal.Actions>
          <button onClick={close} className="btn btn-sm btn-secondary">
            <i className="fa fa-check"></i> No
          </button>
          <button className="btn btn-sm btn-danger" onClick={discardCampaign}>
            <i className="fa fa-trash-o"></i> Eliminar
          </button>
        </Modal.Actions>
      </Modal>

      <div className="card">
        <div className="card-body">
          <NavLink to="/campaigns/new">
            <button type="button" className="btn btn-primary btn-icon-text">
              <i className="mdi mdi mdi-plus btn-icon-prepend"></i>
              Crear campaña
            </button>
          </NavLink>

          <br></br>
          <br></br>

          <ReactTable
            previousText="Anterior"
            nextText="Siguiente"
            loadingText="Cargando..."
            noDataText="Sin registros"
            pageText="Pagina"
            ofText="de"
            rowsText="fila"
            pageJumpText="ir a la pagina"
            rowsSelectorText="fila por pagina"
            data={dataCampaigns}
            filterable
            loading={loadData}
            minRows={1}
            columns={[
              {
                Header: "Nombre campaña",
                accessor: d => {
                  if (!d.cdCampaignConfiguration) return d.campaignId;
                  return d.cdCampaignConfiguration.name;
                },
                filterMethod: (filter, row) =>
                  row[filter.id]
                    .toLowerCase()
                    .includes(filter.value.toLowerCase()),
                id: "name"
              },
              {
                Header: "Fecha creación",
                accessor: d => {
                  if (!d.cdCampaignConfiguration) return "0000-00-00 00:00";
                  return moment.utc(d.cdCampaignConfiguration.creationDate).format(
                    "Y-MM-DD hh:mm"
                  );
                },
                id: "creationDate"
              },
              {
                Filter: SelectStatusFilter,
                Header: "Estado",
                accessor: d => {
                  switch (d.status) {
                    case 0:
                      return "En proceso de configuración";
                    case 1:
                      return "Buscar datos pendientes";
                    case 2:
                      return "Buscando datos";
                    case 3:
                      return "Preparado para lanzar";
                    case 4:
                      return "Descartada";
                    case 5:
                      return "Lanzando";
                    case 6:
                      return "Lanzada";
                    default:
                      return "En proceso de configuración";
                  }
                },
                filter: "includes",
                filterMethod: (filter, row) =>
                  row._original &&
                  row._original.status === Number(filter.value),
                id: "status"
              },
              {
                Cell: cellInfo => {
                  return (
                    <span
                      style={{
                        display: "block",
                        margin: "auto",
                        textAlign: "center"
                      }}
                    >
                      <div className="btn-group" role="group" aria-label="">
                        <NavLink
                          className="btn btn-primary"
                          to={`/campaigns/configure/${cellInfo.value}`}
                        >
                          <i className="mdi mdi-border-color"></i>
                        </NavLink>
                        <button
                          type="button"
                          className="btn btn-danger"
                          disabled={
                            [5, 6].indexOf(cellInfo.original.status) > -1
                              ? true
                              : false
                          }
                          onClick={() =>
                            discardCampaigAlert(cellInfo.value, cellInfo.index)
                          }
                        >
                          <i className="mdi mdi mdi-delete"></i>
                        </button>
                      </div>
                    </span>
                  );
                },
                Header: "",
                accessor: "campaignId",
                filterable: false,
                id: "actions"
              }
            ]}
            defaultPageSize={10}
          />
        </div>
      </div>
    </div>
  );
};

function SelectStatusFilter({ onChange, column: { filterValue } }) {
  // setFilter(event.target.value || undefined)
  return (
    <select
      onChange={event => onChange(event.target.value)}
      value={filterValue}
    >
      <option value="">Todos</option>
      <option value="0">En proceso de configuración</option>
      <option value="1">Buscar datos pendientes</option>
      <option value="2">Buscando datos</option>
      <option value="3">Preparado para lanzar</option>
      {/* <option value="4">Descartada</option> */}
      <option value="5">Lanzando</option>
      <option value="6">Lanzada</option>
    </select>
  );
}

export default Campaigns;
